import { render, staticRenderFns } from "./DepartmentSave.vue?vue&type=template&id=308c694d&"
import script from "./DepartmentSave.vue?vue&type=script&lang=js&"
export * from "./DepartmentSave.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSave.vue?vue&type=style&index=0&id=308c694d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports